/**
 * Created by Filip de Tillier on 14.12.2018.
*/
import filter from 'lodash.filter';
import includes from 'lodash.includes';
/**
 * @module Store/view
 * @description Module for filters
*/


/**
 * @constant State of orders store
 * @type {object}
* */

const state = {
    filters: {
        role: '',
        company: '',
        firstName: '',
        lastName: ''
    },
    sortOrder: {
        field: 'role.name',
        direction: 'asc'
    },
    filtredUsers: []
};

/**
 * @constant Getters
 * @type {object}
**/

const getters = {
    getUsersTableFilters: state => state.filters,
    getUsersTableSortOrder: state => state.sortOrder,
    getUsersIncludingFilters: state => state.filtredUsers
};

/**
 * @constant Mutations
 * @type {object}
**/

const mutations = {
    addUsersTableFilters: (state, filters) => state.filters = filters,
    addUsersTableSortOrder: (state, sortOrder) => state.sortOrder = sortOrder,
    setUsersIncludingFilters: (state, filtredUsers) => state.filtredUsers = filtredUsers
};

/**
 * @constant Actions
 * @type {object}
**/

const actions = {
    async AddUsersTableFilters ({ commit }, filters) {
        commit('addUsersTableFilters', filters);
    },
    async SetUsersTableSortOrder ({ commit }, sortOrder) {
        commit('addUsersTableSortOrder', sortOrder);
    },
    async SetUsersIncludingFilters ({ commit, state }, users) {
        const { company, firstName, lastName, role } = state.filters;
        const filtredUsers = company || firstName || lastName || role ? filter(users, el => {
            let filtredUsers;
            if(company) {
                filtredUsers = includes(el.address.companyName, company);
            }
            if(firstName) {
                filtredUsers = includes(el.person.firstName, firstName);
            }
            if(lastName) {
                filtredUsers = includes(el.person.lastName, lastName);
            }
            if(role) {
                filtredUsers = includes(el.role.name, role);
            }
            return filtredUsers;
        }) : users;
        commit('setUsersIncludingFilters', filtredUsers);
    }
};

export default {
    state,
    getters,
    mutations,
    actions
};